/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";

// Images
import logoXD from "assets/images/small-logos/logo-xd.svg";
import MDCheckbox from "components/MDCheckbox";
import { FormControlLabel } from "@mui/material";
import MDSwitch from "components/MDSwitch";


export default function data() {

  const Company = ({  name }) => (
    <MDBox display="flex" alignItems="left" lineHeight={1}>
    <FormControlLabel control={<MDCheckbox />} label={name} />
  </MDBox>
  );

  return {
    columns: [
      { Header: "دستگاه", accessor: "device",align: "left",fontSize:'12px',hasCheck:true,  },
      { Header: "آخرین بازدید", accessor: "lastSeen", align: "center" },
      { Header: "مکان", accessor: "location", align: "center" },
      { Header: "آدرس IP", accessor: "ip", align: "center" },
      { Header: "عملیات", accessor: "actions", align: "right" },
    ],

    rows: [
      // {
      //   device: <Company  name="ویندوز" />,
      //   location: (
      //     <MDTypography variant="caption" fontSize='sm'>
      //   تهران
      //     </MDTypography>
      //   ),
      //   ip: (
      //       <MDTypography variant="caption" fontSize='sm'>
      //       198.2.2.1
      //     </MDTypography>
      //   ),
      //   actions: (
      //       <MDTypography variant="caption" fontSize='sm' color='primary'>
      //    همین دستگاه
      //     </MDTypography>
      //   ),
      // },
      {
        device: <Company  name="ویندوز" />,
        location: (
          <MDTypography variant="caption" fontSize='sm'>
        تهران
          </MDTypography>
        ),
        lastSeen:(
          <MDTypography variant="caption" fontSize='sm'>
        تهران
          </MDTypography>
        ),
        ip: (
            <MDTypography variant="caption" fontSize='sm'>
            198.2.2.1
          </MDTypography>
        ),
        actions: (
          <MDBox mr={-3}>
      <MDSwitch/>
      </MDBox>
        ),
      },
    ],
  };
}
